export const Armenia = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const Azerbaijan = /^(([A-Z]|[А-Я])\d{8}|([A-Z]|[А-Я])\d{7}|\d{8})$/

export const Belarus = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const Estonia = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const Georgia = /^\d{2}([A-Z]{2}|[А-Я]{2})\d{5}$/

export const Kazakhstan = /^(N\d{7,8}|\d{9})$/

export const Kyrgyzstan = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const Latvia = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const Lithuania = /^\d{8}$/

export const Moldova = /^(([A-Z]{2}|[А-Я]{2})\d{7}|([A-Z]|[А-Я])\d{7})$/

export const Tajikistan = /^\d{9}$/

export const Turkmenistan = /^([A-Z]|[А-Я])\d{7}$/

export const Ukraine = /^(([A-Z]{2}|[А-Я]{2})\d{6}|\d{9})$/

export const Uzbekistan = /^([A-Z]{2}|[А-Я]{2})\d{7}$/

export const passportRegexes = {
  Belarus,
  Armenia,
  Azerbaijan,
  Estonia,
  Georgia,
  Kazakhstan,
  Kyrgyzstan,
  Latvia,
  Lithuania,
  Moldova,
  Tajikistan,
  Turkmenistan,
  Ukraine,
  Uzbekistan,
}
